import { OptionCrmDto } from "./OptionCrmDto";

export class OptionReconductionDto {

    resi_datedebutOption?:Date;
    resi_datefinOption?:Date;
    resi_dateliberationreelle?:Date;
    resi_statutlotcode:number = 852810001
    "resi_lotid@odata.bind"?:string;
    resi_source:string= "Extranet";
}